module.exports = __webpack_public_path__ + "14cedc66cc56f5d409be5c9aef30e1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = 687
// module chunks = 0